var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modalWorkersSelect",
          attrs: {
            id: "modal-workers",
            "content-class": "modal-fullscreen",
            "body-class": "modal-body-fullscreen",
            size: "xl",
            title: _vm.title,
            "ok-only": false,
            "no-fade": true,
            "ok-title": "Добавить в заявку",
            "cancel-title": "Отменить",
            "button-size": "sm",
            "no-close-on-esc": "",
            "no-close-on-backdrop": "",
            scrollable: ""
          },
          on: {
            ok: _vm.rowClickHandler,
            cancel: _vm.hideModal,
            close: _vm.hideModal,
            hidden: _vm.onHidden
          }
        },
        [
          _c(
            "b-row",
            { staticClass: "mb-0" },
            [
              _c(
                "b-col",
                { attrs: { cols: "10" } },
                [
                  _c(
                    "b-card",
                    { attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-card-body",
                        { staticClass: "py-2" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mr-auto",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c(
                                    "b-input-group",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          size: "sm",
                                          placeholder: _vm.$t(
                                            "message.common.search"
                                          )
                                        },
                                        on: { input: _vm.onInput },
                                        model: {
                                          value: _vm.query,
                                          callback: function($$v) {
                                            _vm.query = $$v
                                          },
                                          expression: "query"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-input-group-append",
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                size: "sm",
                                                variant: "info"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.onSearch()
                                                }
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: { icon: "search" }
                                              }),
                                              _vm._v(
                                                " Найти\n                      "
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      attrs: { id: "input_town", size: "sm" },
                                      on: {
                                        change: function($event) {
                                          return _vm.onTownChange()
                                        }
                                      },
                                      model: {
                                        value: _vm.currentTown,
                                        callback: function($$v) {
                                          _vm.currentTown = $$v
                                        },
                                        expression: "currentTown"
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { domProps: { value: -1 } },
                                        [_vm._v("Все города")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.towns, function(option) {
                                        return _c(
                                          "option",
                                          {
                                            key: option.id,
                                            domProps: { value: option.id }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(option.name) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card",
                        { staticClass: "mx-3 mb-2", attrs: { "no-body": "" } },
                        [
                          _c("b-table", {
                            ref: "FreeWorkersTable",
                            staticClass: "mb-0",
                            attrs: {
                              id: "workers",
                              striped: "",
                              small: "",
                              hover: "",
                              "thead-class": "top-fixed-thead thead-light",
                              "table-class": "text-small",
                              responsive: "",
                              "show-empty": "",
                              "empty-text": _vm.$t("message.common.emptyTable"),
                              busy: _vm.isBusy,
                              items: _vm.items,
                              fields: _vm.fields,
                              "tbody-tr-class": _vm.tbodyRowClass,
                              "no-provider-filtering": "",
                              "no-provider-paging": "",
                              "no-provider-sorting": ""
                            },
                            on: {
                              "update:busy": function($event) {
                                _vm.isBusy = $event
                              },
                              "row-clicked": _vm.rowClicked
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "cell(level_efficiency)",
                                fn: function(row) {
                                  return [
                                    _c(
                                      "b-badge",
                                      {
                                        attrs: {
                                          id:
                                            "level-efficiency-badge-" +
                                            row.item.id,
                                          pill: "",
                                          variant: _vm.getLevelEfficiencyStyle(
                                            row.item.level_efficiency
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.getLevelEfficiencyText(
                                                row.item.level_efficiency
                                              )
                                            ) +
                                            "\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    row.item.description !== ""
                                      ? _c(
                                          "b-tooltip",
                                          {
                                            attrs: {
                                              target:
                                                "level-efficiency-badge-" +
                                                row.item.id,
                                              triggers: "hover",
                                              variant: _vm.getLevelEfficiencyStyle(
                                                row.item.level_efficiency
                                              ),
                                              noninteractive: ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(row.item.description) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              },
                              {
                                key: "cell(phone)",
                                fn: function(row) {
                                  return [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.telUrl(row.item.phone)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.phoneString(row.item.phone)
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(passport_url)",
                                fn: function(row) {
                                  return [
                                    row.item.passport_url.length > 0
                                      ? _c(
                                          "a",
                                          {
                                            on: {
                                              click: function($event) {
                                                return _vm.downloadFile(
                                                  row.item.id,
                                                  row.item.passport_url
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              style: { color: "purple" },
                                              attrs: {
                                                icon: "passport",
                                                size: "lg"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("pagination-footer", {
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage
                        },
                        on: {
                          "update:perPage": function($event) {
                            _vm.perPage = $event
                          },
                          "update:per-page": function($event) {
                            _vm.perPage = $event
                          },
                          "page-click": _vm.onPagination
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "footer-list",
                            fn: function() {
                              return [
                                _c("div", [
                                  _vm._v(
                                    "\n                  Всего исполнителей: "
                                  ),
                                  _c("b", [_vm._v(_vm._s(_vm.totalRows))])
                                ])
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "footer-buttons",
                            fn: function() {
                              return [
                                _c("b-pagination", {
                                  attrs: {
                                    pills: "",
                                    "total-rows": _vm.totalRows,
                                    "per-page": _vm.perPage
                                  },
                                  on: { "page-click": _vm.onPagination },
                                  model: {
                                    value: _vm.currentPage,
                                    callback: function($$v) {
                                      _vm.currentPage = $$v
                                    },
                                    expression: "currentPage"
                                  }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "2" } },
                [
                  _c("h6", [
                    _vm._v(
                      "Будут добавлены: " + _vm._s(_vm.selectedItems.length)
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.selectedItems, function(item, index) {
                    return _c("div", { key: item.id }, [
                      _c("small", [_vm._v(_vm._s(item.name))])
                    ])
                  }),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("h6", [_vm._v("Уже в заявке: " + _vm._s(_vm.tws.length))]),
                  _vm._v(" "),
                  _vm._l(_vm.tws, function(item, index) {
                    return _c("div", { key: item.id }, [
                      _c("small", [_vm._v(_vm._s(item.name))])
                    ])
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-478dd8c7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-478dd8c7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Workers/WorkersFree.vue
// module id = null
// module chunks = 